<template>
  <HelloWorld
    hide-mini-program-qr
    android-apk-config-key="xsjd_apk_url"
    ios-app-url="https://apps.apple.com/cn/app/id6755748482"
    custom-download-qr
    :download-qr-code-src="downloadQrCodeSrc"
    :auto-download="autoDownload"
  />
</template>

<script>
import QRCode from 'qrcode'
import HelloWorld from './HelloWorld.vue'
import qrCenterIcon from '@/assets/images/xsjd-qr-icon.png'

export default {
  name: 'XsjdPage',
  components: {
    HelloWorld
  },
  data() {
    return {
      autoDownload: new URLSearchParams(window.location.search).get('download') === '1',
      downloadQrCodeSrc: ''
    }
  },
  async mounted() {
    const downloadOrigin = process.env.VUE_APP_XSJD_DOWNLOAD_ORIGIN || window.location.origin
    const downloadUrl = new URL('/xsjd-download.html', downloadOrigin).toString()

    const qrCodeDataUrl = await QRCode.toDataURL(downloadUrl, {
      width: 400,
      margin: 1,
      errorCorrectionLevel: 'H'
    })

    try {
      const [qrCodeImage, centerIcon] = await Promise.all([
        this.loadImage(qrCodeDataUrl),
        this.loadImage(qrCenterIcon)
      ])
      const canvas = document.createElement('canvas')
      const context = canvas.getContext('2d')
      const iconSize = 72
      const iconPadding = 6
      const backgroundSize = iconSize + iconPadding * 2
      const backgroundX = (qrCodeImage.width - backgroundSize) / 2
      const backgroundY = (qrCodeImage.height - backgroundSize) / 2
      const iconX = backgroundX + iconPadding
      const iconY = backgroundY + iconPadding

      canvas.width = qrCodeImage.width
      canvas.height = qrCodeImage.height
      context.drawImage(qrCodeImage, 0, 0)
      this.drawRoundedRect(context, backgroundX, backgroundY, backgroundSize, backgroundSize, 16)
      context.fillStyle = '#ffffff'
      context.fill()
      context.save()
      this.drawRoundedRect(context, iconX, iconY, iconSize, iconSize, 13)
      context.clip()
      context.drawImage(centerIcon, iconX, iconY, iconSize, iconSize)
      context.restore()

      this.downloadQrCodeSrc = canvas.toDataURL('image/png')
    } catch (error) {
      this.downloadQrCodeSrc = qrCodeDataUrl
    }
  },
  methods: {
    loadImage(source) {
      return new Promise((resolve, reject) => {
        const image = new Image()
        image.onload = () => resolve(image)
        image.onerror = reject
        image.src = source
      })
    },
    drawRoundedRect(context, x, y, width, height, radius) {
      const cornerRadius = Math.min(radius, width / 2, height / 2)

      context.beginPath()
      context.moveTo(x + cornerRadius, y)
      context.lineTo(x + width - cornerRadius, y)
      context.quadraticCurveTo(x + width, y, x + width, y + cornerRadius)
      context.lineTo(x + width, y + height - cornerRadius)
      context.quadraticCurveTo(x + width, y + height, x + width - cornerRadius, y + height)
      context.lineTo(x + cornerRadius, y + height)
      context.quadraticCurveTo(x, y + height, x, y + height - cornerRadius)
      context.lineTo(x, y + cornerRadius)
      context.quadraticCurveTo(x, y, x + cornerRadius, y)
      context.closePath()
    }
  }
}
</script>
